import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import "@/scss/common.scss";
import VueWechatTitle from "vue-wechat-title";
import element from "element-ui";
import "./plugins/directive";
import "./plugins/common";
/*import "element-ui/lib/theme-chalk/select.css";
import "element-ui/lib/theme-chalk/option.css";
import "element-ui/lib/theme-chalk/option-group.css";
import "element-ui/lib/theme-chalk/button.css";
import "element-ui/lib/theme-chalk/slider.css";
import "element-ui/lib/theme-chalk/drawer.css";
import "element-ui/lib/theme-chalk/icon.css";*/
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(VueWechatTitle);
Vue.use(element);
Vue.config.productionTip = false;
Vue.prototype.$bus = new Vue();

new Vue({
  router,
  render: h => h(App)
}).$mount("#app");
